import React, { Component } from 'react';
import './Matikkahmatti.css';
import laskutehtävät from './laskutehtävät.js';
import testit from './testit.js';
import Testi from './Testi';
import {SIVU, RYHMÄ, TYYPPI} from './constants'
import imgExit from './images/exit.svg';
import imgAhmatti from './images/ahmatti.png';

// Sallitaan Array-prototyypin muokkaus ilman, että eslint nostaa
// siitä varoitusta.
/*eslint no-extend-native: ["warn", { "exceptions": ["Array"] }] */

if (!Array.prototype.shuffle) {
  Array.prototype.shuffle = function() {
	for (var eka=0; eka < this.length; eka++) {
		  var toka = Math.floor(Math.random() * this.length)
		  var temp = this[toka]
		  this[toka] = this[eka]
		  this[eka] = temp
	}		
  }
}

const testiryhmat = {
	[RYHMÄ.HAJOTELMAT]: {
    nimi:    "hajotelmat",
    kuvaus:  "Tässä ryhmässä on hajotelmien harjoittamiseen ja testaamiseen liittyvät harjoitteet.",
		testit:  {
			3:   ["H3/300","H3/180"],
			4:   ["H4/300","H4/180"],
      5:   ["H5/300","H5/180"],
      6:   ["H6/300","H6/210"],
      7:   ["H7/300","H7/210"],			
      8:   ["H8/300","H8/210"],			
			9:   ["H9/300","H9/210"],
			10:  ["H10/300","H10/210"],
			"3-10+": ["H3-10+/300","H3-10+/180"],
			"miinus": ["H3-10-/300","H3-10-/180"]
		}	
	},
	[RYHMÄ.KERTOTAULUT]: {
    nimi:    "kertotaulut",
		kuvaus:  "Tässä ryhmässä on kertotaulujen harjoittamiseen ja testaamiseen liittyvät harjoitteet.",
		testit:  {
			 2:   ["K2/0", "K2/210"],			
			 3:   ["K3/0", "K3/210"],			
			 4:   ["K4/0", "K4/210"],			
			 5:   ["K5/0", "K5/210"],			
	 		 6:   ["K6/0", "K6/180"],	
		 	 7:   ["K7/0", "K7/180"],	
			 8:   ["K8/0", "K8/180"],	
			 9:   ["K9/0", "K9/180"],	
			10:   ["K10/0","K10/180"],
	"mini":   ["K50/600","K50/210"],
	"2-10":   ["K100/0","K100/360"],
		}	
	}	
	
}

/**
 * Funktio, joka generoi määritetyn määrän tehtäviä ja sekoittaa ne.
 * @param {*} ryhmä - tehtäväryhmä, josta tehtävät generoidaan
 * @param {*} kategoria - tehtäväkategoria, josta tehtävät generoidaan
 * @param {number} määrä - generoitavien tehtävien kokonaismäärä
 */
function tehtävät(ryhmä,kategoria,määrä) {

	// Alustetaan tulosmuuttuja.
	var tehtävät = [];

  // Jos tehtävien lukumäärä on "loputon", niin luotavien
	// tehtävien määräksi asetetaan 100.
	if (määrä === 0) {
		määrä = 100;
	}

    // kategoria = indeksi.. 

	var tehtävämateriaali
	
  switch (ryhmä) {
		case RYHMÄ.HAJOTELMAT:
			tehtävämateriaali = laskutehtävät.hajotelmat[kategoria];
			break;
		case RYHMÄ.KERTOTAULUT:
			tehtävämateriaali = laskutehtävät.kertolaskut[kategoria];
		  break;
		default: 
		  return tehtävät;
		
	}
		
	// Käydään tehtävämateriaali lävitse.
	for (var i=0; i<tehtävämateriaali.length; i++) {
		
		var tehtävä = tehtävämateriaali[i]
		
		// console.log("tehtävien suhde:")
		// console.log(tehtävä.suhde)
		
		for (var k=0; k<tehtävä.suhde; k++) {

			// Alustetaan tehtävämuuttuja ja tulosmuuttuja.
			var lisättävä = {}
			var tulos = []

			// Lisätään oikeat ja väärät vastaukset.
			tulos.push({"vastaus": tehtävä.oikea, "oikein": true})
			var väärät = tehtävä.väärät
			// console.log(väärät)
			väärät.shuffle()
			// console.log(väärät)
			väärät = väärät.slice(0,3)
			// console.log(väärät)
			for (var j=0; j<väärät.length; j++) {
				var alkio = {}
				alkio.vastaus = väärät[j]
				alkio.oikein = false
				tulos.push(alkio)
			}

			// Sekoitetaan tulostaulukko.
			tulos.shuffle()

			lisättävä.tehtävä = tehtävä.tehtävä
			lisättävä.tulos = tulos

			// Lisätään tehtävä tehtäväjoukkoon.
			tehtävät.push(lisättävä)
			
		}
		
	}

	// console.log(tehtävät)

	tehtävät.shuffle()
	
	tehtävät = tehtävät.slice(0,määrä)
	
	return tehtävät

}



/*
class Testivaihtoehto extends Component {
  render() {
    return <button className="testivaihtoehto" onClick={() => this.props.onClick()}>{this.props.nimi}</button>
  }	
}	
*/


class Matikkahmatti extends Component {
	
  constructor() {
    super();
		  
  	var sivu = SIVU.ETUSIVU  // Asetetaan aloitussivuksi etusivu.
		
    this.state = {
	    sivu: sivu,
			näytetäänPuhekupla: false,
    };
  }
	
	
  aloitatesti(testi) {
    // Generoidaan testipatteri ja tallennetaan se state-muuttujaan.
		
    let suoritettavat = tehtävät(testit[testi].ryhmä, testit[testi].materiaali, testit[testi].tehtäviä)
	  this.setState({testinimi: testit[testi].nimi, suoritettavat: suoritettavat, tyyppi: testit[testi].tyyppi, aika: testit[testi].aika, sivu: SIVU.TESTI, tehtäviä: testit[testi].tehtäviä })	
  }

  palaaTakaisin() {
	  let sivu = this.state.sivu;
	  switch (sivu) {
		case SIVU.INFO:
		  this.setState({sivu: SIVU.ETUSIVU, näytetäänPuhekupla: false});		
			break;
		case SIVU.TESTIRYHMÄ:
      this.setState({sivu: SIVU.ETUSIVU});		
		  break;
		case SIVU.TESTISARJA:
		  this.setState({sivu: SIVU.TESTIRYHMÄ});
		  break;
		case SIVU.TESTITIEDOT:
		  this.setState({sivu: SIVU.TESTISARJA});
		  break;		  
		case SIVU.TESTI:
      this.setState({sivu: SIVU.TESTITIEDOT});
			break;	
		default: 
		  this.setState({sivu: SIVU.ETUSIVU});
	  }
  
  }  

	vaihdaPuhekuplanNäkyvyys() {		
		this.setState({näytetäänPuhekupla: !this.state.näytetäänPuhekupla })
	}
  
  valitseTesti(avain) {
	  this.setState({testi: avain, sivu: SIVU.TESTITIEDOT});
  }	

  valitseTestiryhma(avain) {
	  this.setState({testiryhma: avain, sivu: SIVU.TESTIRYHMÄ})
  }

  valitseTestisarja(avain) {
	  this.setState({testisarja: avain, sivu: SIVU.TESTISARJA})
  }

  näytäLisätiedot() {
		this.setState({sivu: SIVU.INFO})
	}
  
  render() {
	  
        switch (this.state.sivu) {

            case SIVU.ETUSIVU:

                let näytetäänPuhekupla;
								if (this.state.näytetäänPuhekupla) {
									näytetäänPuhekupla = "näytä";
								} else {
									näytetäänPuhekupla = "";
								}

                return (
                    <div className="sivu">
					    
                        <h1>matikkahmatti</h1>
						
                        { 
                          Object.keys(testiryhmat).map(function(avain,index) {								
	                          return <button key={avain} className={"nappi " + avain} onClick={() => this.valitseTestiryhma(avain)}>{testiryhmat[avain].nimi}</button>
                          }.bind(this))
                        }
						
						            <div className="ahmatti"><img src={imgAhmatti} onClick={() => this.vaihdaPuhekuplanNäkyvyys()} alt="matikkahmatti"/></div>
						
						            <div className={"puhekupla " + näytetäänPuhekupla} onClick={() => this.näytäLisätiedot()}>
													 <p>Hei! Olen matikkahmatti ja autan sinua hajotelmien ja kertolaskujen kanssa.</p>
													 <p>Paina tästä, jos haluat tietää lisää minusta.</p>
												</div>
						
					           </div>		  
				        );		
						
						case SIVU.INFO:

						  return (

								<div className="infosivu">

                  <h1>Hyvä oppilas, opettaja ja vanhempi!</h1>

									<p>Ahmatti on tehty auttamaan hajotelmien ja kertotaulujen 
										 automatisoitumista oppilaalle. Se on rakennettu niin, 
										 ettei virheellisellä vastauksella pääse eteenpäin, 
										 vaan tehtävän suorittamista pitää jatkaa, kunnes oikea 
										 vastaus löytyy. Virheellisesti vastatut tehtävät 
										 toistuvat myös saman tien uudelleen, jotta oikeat 
										 suoritukset vahvistuisivat. Olemme arvottaneet tehtävät 
										 niin, että vaikeampia tehtäviä harjoitellaan suhteessa 
										 useammin kuin helpompia.</p>

									<p>Opettaja voi käyttää Ahmattia sähköisenä läksynä 
										 esimerkiksi niin, että matikan kirjan kotitehtävien 
										 yhteyteen liitetään tiedote, jossa kerrotaan, mitä 
										 hajotelmaa/kertotaulua oppilaan tulee harjoitella. 
										 Kotiväki kuittaa tiedotteeseen tai oppikirjaan, että 
										 oppilas on harjoituksen suorittanut. Ahmatin testaa 
										 -osioita voidaan käyttää halutun hajotelman/kertotaulun 
										 osaamisen varmistamiseen niin, että luokan oppilaat 
										 tekevät testin yhtä aikaa ja testin jälkeen opettaja 
										 tarkistaa oppilaiden saamat pisteet.  Samalla hän 
										 saa selville, kuka vielä tarvitsee harjoitusta ja 
										 kuka jo osaa kyseisen asian. Hyväksytyn rajan voi 
										 jokainen opettaja itse harkita luokkansa mukaan.</p>
										
									<p>Toivomme Ahmatin tuovan oppilaille onnistumisen iloa
										 hajotelmien ja kertotaulujen osaamisen vahvistuessa 
										 ja sitä kautta monien matematiikan mutkien 
										 helpottuessa. Jotkut oppilaat ahdistuvat esimerkiksi 
										 suuren tehtävämonisteen nähdessään, joten he saattavat
										 hyötyä Ahmatilla harjoittelusta. Ahmatissa tehtävät 
										 selätetään yksi kerrallaan eivätkä muut tehtävät ole 
										 näkyvissä.</p>

									<p>Toivottavasti Ahmatti tuo helpotusta myös perheiden 
									   arkeen, sillä Ahmatilla lapsi voi itsenäisesti 
										 harjoitella suurenkin määrän tehtäviä. Harjoituksen 
										 loputtua vanhempi voi tehtyjen tehtävien määrästä 
										 päätellä, onko lapsi todella käyttänyt ajan tehtävien 
										 harjoittelemiseen, vai johonkin sijaistoimintaan <span role="img" aria-label="smile">😊</span>.</p>

									<p>Hanna-Leena haluaa kiittää yhteistyöstä suuresti
										 arvostamaansa erityisopettaja Kirsi Heinoa, joka on 
										 jakanut hänen kanssaan intohimon matematiikan 
										 oppimisen tukemiseen ja antanut hyviä vinkkejä 
										 Ahmatin kehittämiseen. Myös Sammun koulun ihanat 
										 ekaluokan oppilaat ovat Ahmattia käyttäessään 
										 auttaneet kehittämään sitä.</p>

									<p>Pekka on koodannut Ahmatin ja suunnitellut sen 
										 ulkoasun yksin, yhdessä olemme miettineet oppimista 
										 tukevia asioita ja tehtäväsarjojen sisältöjä 
										 painotuksineen. Toivomme saavamme puuttuvat 
										 tehtäväsarjat Ahmattiin mahdollisimman pian.</p>

									<p>Pekka ja Hanna-Leena Aalto</p>	 

									<button className={"nappi hajotelma"} onClick={() => this.palaaTakaisin()}>Selvä homma!</button>	 
 
                </div>

							);

            case SIVU.TESTIRYHMÄ:

                return (
                    <div className={"sivu sivu-" + this.state.testiryhma}>
					    
                        <h1>{testiryhmat[this.state.testiryhma].nimi}</h1>
						
						            <div className="testit">
						
                            { 
                                Object.keys(testiryhmat[this.state.testiryhma].testit).map(function(avain,index) {	
	                                return <button key={avain} className={"nappi " + this.state.testiryhma} onClick={() => this.valitseTestisarja(avain)}>{avain}</button>
                                }.bind(this))
                            }
						
						</div>
						
						<div className="button-exit">
						  <button className="imageButton" onClick={() => this.palaaTakaisin()}><img src={imgExit} alt="takaisin"/></button>
						</div>
						
						
						
					</div>		  
				);		
				
			case SIVU.TESTISARJA: 
			
			    return (
					  <div className={"sivu sivu-" + this.state.testiryhma}>
					
					  <h1>{testiryhmat[this.state.testiryhma].nimi} {this.state.testisarja}</h1>

						<div className="testisarjat">
					
                            { 
                                Object.keys(testiryhmat[this.state.testiryhma].testit[this.state.testisarja]).map(function(avain,index) {		
																	let testitunnus = testiryhmat[this.state.testiryhma].testit[this.state.testisarja][avain];													                  
	                                return <div key={index}><button className={"nappi " + this.state.testiryhma} onClick={() => this.valitseTesti(testitunnus)}>{testit[testitunnus].lyhytnimi}</button></div>
                                }.bind(this))
                            }					
					
					  </div>
					  
					  <div className="button-exit">
						<button className="imageButton" onClick={() => this.palaaTakaisin()}><img src={imgExit} alt="takaisin"/></button>
					  </div>
						
					  				  
					  
					</div>
				);				
						
			case SIVU.TESTITIEDOT: 
			
          let nappiteksti = ""
					if (testit[this.state.testi].tyyppi === TYYPPI.TESTI) {
						nappiteksti = "Aloita testi";
					} else {
						nappiteksti = "Aloita harjoitus";
					}

          
			    return (
					<div className={"sivu sivu-" + this.state.testiryhma}>
					  <div className="testitiedot">
					  <h1>{testit[this.state.testi].nimi}<div>({testit[this.state.testi].tyyppi})</div></h1>
					  <p>{testit[this.state.testi].kuvaus}</p>
					  <button className={"nappi " + this.state.testiryhma} onClick={() => this.aloitatesti(this.state.testi)}>{nappiteksti}</button>
					  </div>

						<div className="button-exit">
						  <button className="imageButton" onClick={() => this.palaaTakaisin()}><img src={imgExit} alt="takaisin"/></button>
						</div>
						
						

					</div>
				);
				
			case SIVU.TESTI:			
			
				return (			
				  <Testi testinimi={this.state.testinimi} 
					       tehtävät={this.state.suoritettavat}
								 tehtäviä={this.state.tehtäviä} 
								 aika={this.state.aika} 
								 tyyppi={this.state.tyyppi} 
								 testiryhmä={this.state.testiryhma} 
								 lopeta={() => this.palaaTakaisin()} />			
				);

			default:

			  return (

          <div className="sivu">
            <p>Hups, nyt meni jokin vikaan. Päädyit jonkin sattuman kautta ihan väärälle sivulle..</p>
						<p>Pahoittelut</p>
					</div>

				);

		}	
  }
}

export default Matikkahmatti;




// WEBPACK FOOTER //
// ./src/Matikkahmatti.js